import React from 'react';
import { useTranslation } from 'react-i18next';

interface ErrorMessageProps {
  title?: string;
  message?: string;
  icon?: string;
  iconColor?: string;
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({ 
  title, 
  message, 
  icon = 'ti ti-alert-triangle', 
  iconColor = 'text-warning' 
}) => {
  const { t } = useTranslation();
  
  return (
    <div className="card">
      <div className="card-body text-center py-5">
        <i className={`${icon} ${iconColor} ti-3x mb-3`}></i>
        <h5>{title || t('error')}</h5>
        <p>{message || t('error_message')}</p>
      </div>
    </div>
  );
};

export default ErrorMessage;
